import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import { isEmpty } from "../../utils/FrontEndHelpers";
import styled from "styled-components";
import { CircularProgress } from "@material-ui/core";
import ZoneService from "../../services/ZoneService";
import SessionService from "../../services/SessionService";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "0 10px",
  },
  addressDiv: {
    marginRight: theme.spacing(1),
  },
  lotDiv: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  plateNumberInput: {
    width: "160px",
  },
  plateStateInput: {
    width: "120px",
  },
  codeInput: {
    width: "100%",
  },
  hoursInput: {
    width: "90px",
    height: "51px",
    marginLeft: "6px !important",
  },
  licenseInputDiv: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

const MemberCheckoutPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [zone, setZone] = useState([]);
  const [vehiclePlate, setVehiclePlate] = useState("");
  const [vehicleState, setVehicleState] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [code, setCode] = useState("");
  const { locationId, zoneId } = useParams();

  const getZoneInfo = async () => {
    setIsLoading(true);

    const zoneInfo = {
      locationId,
      zoneId,
    };

    try {
      const zoneService = new ZoneService();
      const {
        data: { data },
      } = await zoneService.get(zoneInfo);

      setZone(data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getZoneInfo();
    // eslint-disable-next-line
  }, []);

  const handlePark = async () => {
    if (isEmpty(vehiclePlate) || isEmpty(vehicleState)) {
      setErrorMessage("Please provide a valid license plate number and state");
      return;
    }

    if (isEmpty(code)) {
      setErrorMessage("Please provide a valid code");
      return;
    }

    const sessionService = new SessionService();
    try {
      const memberCodeObj = {
        code,
        locationId: zone?.location._id,
        zoneId: zone?.zone._id,
        plateNumber: vehiclePlate,
      };
      const res = await sessionService.memberCode(memberCodeObj);
      if (res.data.success) {
        history.push(
          `/locations/${memberCodeObj.locationId}/zones/${memberCodeObj.zoneId}/members/receipt`
        );
      } else {
        setErrorMessage(res.data.message);
      }
    } catch (err) {
      console.log(err);
      setErrorMessage("Please provide a valid code");
      return;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          fontSize: 24,
          fontWeight: 600,
          marginBottom: 12,
          color: "#fff",
          backgroundColor: "#12b981",
          height: 80,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        OPS Parking
      </div>
      <Container>
        <ZoneSection>
          <ZoneLabel>ZONE</ZoneLabel>
          <ZoneNumber>{zone?.zone?.zoneNumber}</ZoneNumber>

          <LocationTitle>{zone?.location?.name}</LocationTitle>

          <InfoRow>
            <IconWrapper>
              <LocationPin size={18} />
            </IconWrapper>
            <InfoText>{zone?.location?.address}</InfoText>
          </InfoRow>
        </ZoneSection>

        <FormSection>
          <div className={classes.licenseInputDiv}>
            <TextField
              label={"License Plate Number"}
              name="vehiclePlate"
              classes={{ root: classes.plateNumberInput }}
              InputLabelProps={{
                style: { fontSize: "16px" },
              }}
              inputProps={{
                maxLength: 8,
                style: { textTransform: "uppercase" },
              }}
              variant="outlined"
              onChange={(e) => setVehiclePlate(e.target.value)}
              value={vehiclePlate}
              disabled={isLoading}
              style={{ width: "60%" }}
            />{" "}
            <TextField
              label={"License State"}
              name="vehicleState"
              classes={{ root: classes.plateStateInput }}
              InputLabelProps={{
                style: { fontSize: "16px" },
              }}
              inputProps={{
                maxLength: 2,
                style: { textTransform: "uppercase" },
              }}
              variant="outlined"
              onChange={(e) => setVehicleState(e.target.value)}
              value={vehicleState}
              disabled={isLoading}
              style={{ width: "35%" }}
            />{" "}
          </div>

          <PriceRow>
            <TextField
              label={"Code"}
              name="code"
              InputLabelProps={{
                style: { fontSize: "16px" },
              }}
              inputProps={{
                style: { textTransform: "uppercase" },
              }}
              variant="outlined"
              onChange={(e) => setCode(e.target.value)}
              value={code}
              disabled={isLoading}
              style={{ width: "100%" }}
            />{" "}
          </PriceRow>

          <Divider />

          <TotalRow>
            <TotalValue>Free For All Church Visitors</TotalValue>
          </TotalRow>

          {isLoading ? (
            <CircularProgress />
          ) : (
            <ContinueButton onClick={handlePark}>
              <ButtonText>CONTINUE</ButtonText>
              &gt;
            </ContinueButton>
          )}

          {errorMessage && (
            <div
              style={{
                color: "red",
                fontSize: "14px",
                marginTop: "10px",
                textAlign: "center",
              }}
            >
              {errorMessage}
            </div>
          )}
        </FormSection>
      </Container>
    </div>
  );
};

export const ContinueButton = styled.button`
  height: 50px;
  width: 100%;
  margin-top: 20px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  background-color: #12b981;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  &:hover {
    background-color: #0db17c;
  }
`;

// Styled Components
const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  overflow: hidden;
`;

const ZoneSection = styled.div`
  padding: 24px;
`;

const ZoneLabel = styled.h2`
  font-size: 14px;
  text-transform: uppercase;
  color: #6b7280;
  font-weight: 500;
  margin: 0 0 8px 0;
  letter-spacing: 0.05em;
`;

const ZoneNumber = styled.div`
  font-size: 96px;
  font-weight: bold;
  color: #12b981;
  line-height: 1;
  margin-bottom: 24px;
`;

const LocationTitle = styled.h3`
  font-size: 24px;
  text-transform: capitalize;
  font-weight: bold;
  color: gray;
  margin: 0 0 16px 0;
  padding-left: 12px;
  border-left: 4px solid #12b981;
  line-height: 1.2;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  width: 70%;
`;

const IconWrapper = styled.div`
  color: #12b981;
  margin-right: 12px;
  display: flex;
  align-items: center;
`;

const InfoText = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 12px;
`;

const FormSection = styled.div`
  padding: 24px;
`;

const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const Divider = styled.hr`
  border: 0;
  height: 1px;
  background-color: #e5e7eb;
  margin: 16px 0;
`;

const TotalRow = styled(PriceRow)`
  margin-top: 16px;
`;

const TotalValue = styled.span`
  font-weight: bold;
  color: gray;
  font-size: 24px;
  text-align: center;
`;

const ButtonText = styled.span`
  margin-right: 8px;
`;

// Location Pin Icon Component
const LocationPin = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MemberCheckoutPage;
